// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { CompaniesRoutingModule } from './companies-routing.module';

// Custom packages - Components
import { FireSafetyDocsAddDocDialogComponent } from "src/app/modules/companies/components/add-fire-safety-doc-dialog/add-fire-safety-doc-dialog.component";
import { AddPhonebookContactDialogComponent } from 'src/app/modules/companies/components/add-phonebook-dialog/add-phonebook-dialog.component';
import { PrivacyStudioDocsAddDocDialogComponent } from 'src/app/modules/companies/components/add-privacy-studio-doc-dialog/add-privacy-studio-doc-dialog.component';
import { AddSubUserDialogComponent } from 'src/app/modules/companies/components/add-sub-user-dialog/add-sub-user-dialog.component';
import { FireSafetyDocsEditDocDialogComponent } from "src/app/modules/companies/components/edit-fire-safety-doc-dialog/edit-fire-safety-doc-dialog.component";
import { EditPhonebookContactDialogComponent } from 'src/app/modules/companies/components/edit-phonebook-dialog/edit-phonebook-dialog.component';
import { PrivacyStudioDocsEditDocDialogComponent } from 'src/app/modules/companies/components/edit-privacy-studio-doc-dialog/edit-privacy-studio-doc-dialog.component';
import { FireSafetyDocsQrCodeDialogComponent } from "src/app/modules/companies/components/fire-safety-qr-code-dialog/fire-safety-qr-code-dialog.component";
import { GeneratePrivacyDocsDialogComponent } from 'src/app/modules/companies/components/generate-privacy-docs-dialog/generate-privacy-docs-dialog.component';
import { ImportPhonebookContactDialogComponent } from 'src/app/modules/companies/components/import-phonebook-dialog/import-phonebook-dialog.component';
import { PrintQrcodeDialogComponent } from 'src/app/modules/companies/components/print-qrcode-dialog/print-qrcode-dialog.component';
import { PrivacyDocsLinkDialogComponent } from 'src/app/modules/companies/components/privacy-docs-link-dialog/privacy-docs-link-dialog.component';
import { PrivacyDocsQrCodeDialogComponent } from 'src/app/modules/companies/components/privacy-docs-qr-code-dialog/privacy-docs-qr-code-dialog.component';
import { PrivacyStudioDocsQrCodeDialogComponent } from 'src/app/modules/companies/components/privacy-studio-docs-qr-code-dialog/privacy-studio-docs-qr-code-dialog.component';
import { StudioPrivacyTemplatesDialogComponent } from 'src/app/modules/companies/components/studio-privacy-templates-dialog/studio-privacy-templates-dialog.component';
import { AddCompanyComponent } from 'src/app/modules/companies/pages/add-company/add-company.page';
import { CompaniesListComponent } from 'src/app/modules/companies/pages/companies-list/companies-list.page';
import { CompanyDetailComponent } from 'src/app/modules/companies/pages/company-detail/company-detail.page';
import { PhonebookComponent } from 'src/app/modules/companies/pages/phonebook/phonebook.page';
import { ViewCompanyComponent } from 'src/app/modules/companies/pages/view-company/view-company.page';
import { GenericDocsModule } from 'src/app/modules/generic-docs/generic-docs.module';
import { FileManagerModule } from 'src/app/shared/components/file-manager/file-manager.module';
import { FileManagerService } from 'src/app/shared/services/file-manager.service';
import { CompaniesSuspendedListComponent } from './pages/companies-suspended-list/companies-suspended-list.page';
import { CompaniesInformativeNoteListComponent } from './pages/companies-informative-note-list/companies-informative-note-list.page';

import { AddPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/add-platform-note-dialog/add-platform-note-dialog.component';
import { AssociatePropertiesPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/associate-properties-platform-note-dialog/associate-properties-platform-note-dialog.component';
import { EditPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/edit-platform-note-dialog/edit-platform-note-dialog.component';
import { ViewPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/view-platform-note-dialog/view-platform-note-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    CompaniesRoutingModule,
    PublicModule,
    FileManagerModule,
    GenericDocsModule,
  ],
  declarations: [
    CompaniesListComponent,
    CompaniesSuspendedListComponent,
    CompaniesInformativeNoteListComponent,
    CompanyDetailComponent,
    AddCompanyComponent,
    ViewCompanyComponent,
    AddSubUserDialogComponent,
    PhonebookComponent,
    AddPhonebookContactDialogComponent,
    EditPhonebookContactDialogComponent,
    ImportPhonebookContactDialogComponent,
    PrintQrcodeDialogComponent,
    FireSafetyDocsAddDocDialogComponent,
    FireSafetyDocsEditDocDialogComponent,
    FireSafetyDocsQrCodeDialogComponent,
    PrivacyDocsQrCodeDialogComponent,
    PrivacyDocsLinkDialogComponent,
    GeneratePrivacyDocsDialogComponent,
    PrivacyStudioDocsAddDocDialogComponent,
    PrivacyStudioDocsEditDocDialogComponent,
    PrivacyStudioDocsQrCodeDialogComponent,
    StudioPrivacyTemplatesDialogComponent,
  ],
  entryComponents: [
    AddSubUserDialogComponent,
    AddPhonebookContactDialogComponent,
    EditPhonebookContactDialogComponent,
    ImportPhonebookContactDialogComponent,
    PrintQrcodeDialogComponent,
    FireSafetyDocsAddDocDialogComponent,
    FireSafetyDocsEditDocDialogComponent,
    FireSafetyDocsQrCodeDialogComponent,
    PrivacyDocsQrCodeDialogComponent,
    PrivacyDocsLinkDialogComponent,
    GeneratePrivacyDocsDialogComponent,
    PrivacyStudioDocsAddDocDialogComponent,
    PrivacyStudioDocsEditDocDialogComponent,
    PrivacyStudioDocsQrCodeDialogComponent,
    StudioPrivacyTemplatesDialogComponent,
    AddPlatformNoteDialogComponent,
    ViewPlatformNoteDialogComponent,
    EditPlatformNoteDialogComponent,
    AssociatePropertiesPlatformNoteDialogComponent,
  ],
  exports: [
  ],
  providers: [
    FileManagerService,
  ]
})
export class CompaniesModule { }
